import React, { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useComplementResults } from "./ComplementResultsLogic";
import { ComplementResultsFilter } from "./ComplementResultsFilter";
import { ComplementResultsTable } from "./ComplementResultsTable";
import { ComplementTrends } from "./ComplementTrends";
import { Table, ColorStripe, PageNavigation, PermissionDenied } from "../index";
import { useAuth } from "../../contexts/AuthContext";

export const ComplementResults = ({ patient, care, checkin }) => {
  const { checkLicense } = useAuth();
  const [activeTab, setActiveTab] = useState("results");

  if (!checkLicense("complement")) {
    return <PermissionDenied />;
  }

  const {
    samplings,
    selectedSampling,
    filterOptions,
    dateRange,
    loading,
    error,
    handleFilterChange,
    handleDateRangeChange,
    handleSamplingSelect,
    copyToClipboard,
    patientData,
    table,
    columns,
    patientRiskLevel,
    areaOrderById,
    paramOrderByDefId,
    parameterDefinitionsById,
  } = useComplementResults(patient, care, checkin);

  const filterMethods = useForm({
    defaultValues: {
      filterType: filterOptions || "all",
      dateFrom: "",
      dateTo: "",
    },
  });

  const handleTabClick = (e) => {
    setActiveTab(e.target.id);
  };

  if (loading) {
    return <div>Načítání...</div>;
  }

  if (error) {
    return <div>Chyba při načítání dat: {error}</div>;
  }

  return (
    <FormProvider {...filterMethods}>
      <div className="complement-results">
        <div className="patient-profile pharmacological-plan">
          <div className="myContent">
            <div className="grid-row">
              <div className="grid-column">
                {/* Informace o pacientovi */}
                {!table.loading && table.data && (
                  <>
                    <Table
                      data={table.data}
                      columns={columns}
                      pharmaPlan={false}
                      careType="complement"
                    />
                    <ColorStripe
                      className={`color-stripe-${patientRiskLevel}`}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* Filtrovací sekce */}
        <ComplementResultsFilter
          filterOptions={filterOptions}
          dateRange={dateRange}
          onFilterChange={handleFilterChange}
          onDateRangeChange={handleDateRangeChange}
        />

        {/* Tab navigácia */}
        <div className="form-row m-bot-0">
          <PageNavigation className="sub-page-navigation present">
            <div>
              <a
                className={activeTab === "results" ? "active" : null}
                id="results"
                onClick={handleTabClick}
              >
                Výsledky komplementu
              </a>
            </div>
            <div>
              <a
                className={activeTab === "trends" ? "active" : null}
                id="trends"
                onClick={handleTabClick}
              >
                Laboratorní trendy
              </a>
            </div>
          </PageNavigation>
        </div>

        {/* Obsah tabov */}
        {activeTab === "results" && (
          <div className="complement-results-section">
            <ComplementResultsTable
              samplings={samplings}
              selectedSampling={selectedSampling}
              onSamplingSelect={handleSamplingSelect}
              onCopyToClipboard={copyToClipboard}
              areaOrderById={areaOrderById}
              paramOrderByDefId={paramOrderByDefId}
            />
          </div>
        )}

        {activeTab === "trends" && (
          <div className="complement-trends-section">
            <ComplementTrends
              samplings={samplings}
              onCopyToClipboard={copyToClipboard}
              patientGender={patient?.gender}
              areaOrderById={areaOrderById}
              paramOrderByDefId={paramOrderByDefId}
              parameterDefinitionsById={parameterDefinitionsById}
            />
          </div>
        )}
      </div>
    </FormProvider>
  );
};
